module.exports = __webpack_public_path__ + "img/FLSH7.6c1aab2a.svg";